// eslint-disable-next-line @typescript-eslint/ban-ts-comment -- third party code
// @ts-nocheck
/* eslint-disable */
// This is third party code, so we don't lint it.

import authService from '@/services/zybook-auth-service';

export function initializeHopscotch() {
    (function (w, d) {
        if (typeof w === 'undefined') return;
        w.Hopscotch =
            w.Hopscotch ||
            function () {
                (w.Hopscotch.q = w.Hopscotch.q || []).push(arguments);
            };
        var elm = d.createElement('div');
        elm.setAttribute('data-widget-host', 'hopscotch');
        elm.setAttribute('data-props-api-key', 'f0913f0d-6842-4dfa-bc0f-cffe565e294a');
        d.getElementsByTagName('body')[0].appendChild(elm);
        var s = d.createElement('script');
        s.src = 'https://app.hopscotch.club/widget.js?';
        s.async = 1;
        s.defer = 1;
        d.getElementsByTagName('body')[0].appendChild(s);
    })(window, document);

    window.Hopscotch('identify', {
        hop_visitor_lookup_id: authService.getUserId(),
    });
}
